<template>
  <div class="chat-message mb-2" :class="{ flipped: chat.senderType == flipped }">
    <div class="chat-avatar">
      <v-tooltip bottom>
        <v-avatar slot="activator" size="32">
          <v-img
            contain
            max-width="32"
            :src="chat.sender.avatar || '/img/missing/avatars/original.png'"
          />
        </v-avatar>
        <span>
          {{ chat.sender.fullName }}
          <span v-if="chat.senderType === 'Administrator'">from Leaply</span>
          <span v-if="chat.senderType === 'Client' && flipped !== 'Client'">from {{ chat.application.opportunity.organization }}</span>
        </span>
      </v-tooltip>
    </div>
    <div class="content-holder grey lighten-2 mx-2 px-2 pt-1 text-xs-left">
      <Markdown :html="false" :source="chat.content" class="markdown" />
      <div class="timestamp caption grey--text text--darken-1 text-xs-right">
        <v-tooltip bottom v-if="showReadAt">
          <v-icon slot="activator" small color="info darken-1"> mdi-check </v-icon>
          <span>Read at {{ new Date(chat.readAt) | date("HH:mm 'on' d MMM yyyy") }}</span>
        </v-tooltip>
        {{ new Date(chat.createdAt) | date("HH:mm 'on' d MMM yyyy") }}
      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'

// Vue Component
export default {
  components: { Markdown },
  name: 'ChatMessage',
  props: ['chat', 'flipped'],
  computed: {
    showReadAt() {
      // Hide read at if you're the reader
      if (this.flipped == 'Candidate' && this.chat.senderType != 'Candidate')
        return false
      return this.chat.readAt
    },
  },
}
</script>

<style>
.chat-message {
  display: flex;
}
.chat-message.flipped {
  flex-direction: row-reverse;
}
.chat-message .content-holder {
  border-radius: 0 8px 8px 8px;
}
.chat-message.flipped .content-holder {
  border-radius: 8px 0 8px 8px;
}
.chat-message .timestamp {
  margin-top: -1em;
}
.chat-message .timestamp .v-icon {
  padding-bottom: 2px;
}

.chat-message strong {
  font-weight: 700;
}
</style>
